/* eslint-disable no-console */
import {Col, Form, Row, Select} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';

import {facilitySelectKey} from '../pages/orgManager/Utils/InfraStructureProfile/constant/facilitySelectConst';
import {rowGutter} from '../pages/orgManager/Utils/OrgProfile/Forms/Constants/Common';
import {yearSelect} from '../utils/FormUtils/yearSelect';

const Year: React.FC<{
  setSelectedYear: React.Dispatch<React.SetStateAction<string>>;
  isESG?: boolean;
  selectFirst?: boolean;
  noPadding?: boolean;
  noBottomMargin?: boolean;
  colSpan?: number;
  isDisabled?: boolean;
}> = ({
  setSelectedYear,
  isESG = false,
  selectFirst = false,
  noPadding = false,
  noBottomMargin = false,
  colSpan = 4,
  isDisabled = false
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const yearFilter = yearSelect();

  const [form] = useForm();
  const {setFields} = form;

  const handleSearch = (event: {name: string; value: string}) => {
    const {name, value} = event;
    searchParams.set(name, value);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    if (selectFirst) {
      handleSearch({
        name: 'selectedYear',
        value: yearFilter?.[0]?.value
      });
      setSelectedYear(yearFilter?.[0]?.value);
    }
    setFields([
      {
        name: facilitySelectKey.year,
        value: searchParams.get('selectedYear') ?? undefined
      }
    ]);
  }, [searchParams]);

  return (
    <Form form={form}>
      <Row
        gutter={rowGutter}
        style={{
          marginTop: `${isESG ? 'none' : '16px'}`,
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <Col
          className="gutter-row"
          span={colSpan}
          style={{
            marginLeft: `${isESG ? 'none' : '25px'}`,
            padding: `${noPadding ? '0px' : '0px 8px'}`
          }}
        >
          <Form.Item
            name="year"
            label={`${isESG ? '' : 'Year'}`}
            labelCol={{span: 24}}
            initialValue={selectFirst ? yearFilter?.[0].value : undefined}
            style={{marginBottom: `${noBottomMargin ? '0px' : '24px'}`}}
          >
            <Select
              placeholder="Year"
              options={yearFilter}
              size="middle"
              disabled={isDisabled}
              onChange={(e) => {
                setSelectedYear(e);
                handleSearch({name: 'selectedYear', value: e});
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default Year;
